import { Messages } from 'primereact/messages';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiClient } from '../../../api';
import { getErrorMessage } from '../../../utils/errors';
import { ButtonAdd } from '../../components/Buttons';
import { showErrorMessage } from '../../utils/messages';
import { MeetingTable } from './components/MeetingTable';
import { MeetingBreadCrumb } from './components/MeetingBreadCrumb';

export default function Meetings() {
    const { municipalityId, bodyType, termId } = useParams();

    const [meetings, setMeetings] = useState(null);
    const [loading, setLoading] = useState(true);

    const msgs = useRef(null);

    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const meetingsResponse = await getApiClient().getAdminMeetingByMunicipalityIdAndBodyAndTermId(municipalityId, bodyType, Number(termId));
                setMeetings(meetingsResponse);
            } catch (error) {
                const errorMessage = getErrorMessage(error);
                showErrorMessage(msgs, errorMessage ?? 'Nepodařilo se načíst zasedání');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [municipalityId, termId]);

    return (
        <>
            <MeetingBreadCrumb />
            <h1>Zasedání</h1>

            <div className='page__buttons'>
                <ButtonAdd
                    label='Přidat zasedání'
                    onClick={() => {
                        navigate(`/admin/municipality/${municipalityId}/${bodyType}/funkcni-obdobi/${termId}/zasedani/new`);
                    }}
                />
            </div>

            <Messages ref={msgs} className='page__messages' />

            <MeetingTable meetings={meetings} loading={loading} />
        </>
    );
}
